import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/contexts/LangContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import LeadModal from "@/components/LeadModal";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [leadOpen, setLeadOpen] = useState(false);

  useEffect(() => {
    // Health check (silent)
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App" data-testid="home-page">
      <Navbar onOpenLead={() => setLeadOpen(true)} />
      <main>
        <Hero onOpenLead={() => setLeadOpen(true)} />
        <Ticker />
        <Services />
        <Portfolio />
        <About />
        <Process />
        <Testimonials />
        <CTASection onOpenLead={() => setLeadOpen(true)} />
        <Footer onOpenLead={() => setLeadOpen(true)} />
      </main>
      <LeadModal open={leadOpen} onOpenChange={setLeadOpen} />
      <WhatsAppWidget />
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
